import closeSquareIcon from "@public/img/close-square.svg";
import { getAvatar, PROFILE_AVATAR_IDS } from "@/component/commom/avatar-widget";
import React, { useEffect } from "react";

type AvatarPickerDialogProps = {
    selectedAvatar: number;
    onSelect: (avatarId: number) => void;
    onClose: () => void;
};

export default function AvatarPickerDialog({ selectedAvatar, onSelect, onClose }: AvatarPickerDialogProps) {
    useEffect(function () {
        var prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function () {
            document.body.style.overflow = prev;
        };
    }, []);

    useEffect(function () {
        var onKey = function (e: KeyboardEvent) {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", onKey);
        return function () {
            window.removeEventListener("keydown", onKey);
        };
    }, [onClose]);

    var handleSelect = function (avatarId: number) {
        onSelect(avatarId);
        onClose();
    };

    return (
        <div className="avatar-picker-overlay" onClick={onClose}>
            <div className="avatar-picker-overlay__wrap">
                <div className="avatar-picker-overlay__cell">
                    <div
                        className="avatar-picker-dialog"
                        onClick={function (e) {
                            e.stopPropagation();
                        }}
                        dir="rtl"
                    >
                        <div className="avatar-picker-dialog__header">
                            <p className="avatar-picker-dialog__title">انتخاب آواتار</p>
                            <button type="button" onClick={onClose} className="avatar-picker-dialog__close">
                                <img src={closeSquareIcon} alt="بستن" />
                            </button>
                        </div>

                        <div className="avatar-picker-dialog__body">
                            <div className="avatar-picker-dialog__grid">
                                {PROFILE_AVATAR_IDS.map(function (id) {
                                    var src = getAvatar(id);
                                    if (!src) {
                                        return null;
                                    }

                                    var isSelected = selectedAvatar === Number(id);
                                    var btnClass = "avatar-picker-dialog__btn";
                                    if (isSelected) {
                                        btnClass = btnClass + " avatar-picker-dialog__btn--selected";
                                    }

                                    return (
                                        <div key={id} className="avatar-picker-dialog__item">
                                            <button
                                                type="button"
                                                onClick={function () {
                                                    handleSelect(Number(id));
                                                }}
                                                className={btnClass}
                                            >
                                                <img
                                                    src={src}
                                                    alt={"آواتار " + id}
                                                />
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
